export var scrollToRef = function scrollToRef(ref, block) {
  ref && ref.current && ref.current.scrollIntoView({
    behavior: "smooth",
    block: block || "start"
  });
};